import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function Content21({data}) {
    const {content21Text, content21Title, content21Image} = data
    return (
        <div className='image-radius-pattern-2 img-r-rt-img-col'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-7'>
                        <div className='image-l-patten-content'>
                            <h2 className='heading-level-2 blue-color'>
                                {content21Title && parser(content21Title)}
                            </h2>
                            <div className='hide-desk'>
                                <div className='image-l-patrn-2 col-push-right img-blue-bg'>
                                    <GatsbyImage
                                        image={getImage(content21Image?.localFile)}
                                        alt='image'
                                    />
                                </div>
                            </div>
                            <p>{content21Text && parser(content21Text)}</p>
                        </div>
                    </div>
                    <div className='col-md-5'>
                        <div className='image-l-patrn-2 col-push-right img-blue-bg hide-mobile'>
                            <GatsbyImage
                                image={getImage(content21Image?.localFile)}
                                alt='image'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
